type Props = {
  readonly children: React.ReactNode;
};

const StaticPageLayout = ({ children }: Props) => (
  <div className="flex w-full flex-1 flex-col">{children}</div>
);

export default StaticPageLayout;
